import './pie-chart.directive.ajscss';

import { isNumber, toJson } from 'angular';
import * as d3 from 'd3';

export const PieChartDirective = [
  '$log',
  $log => {
    function link(scope, element, attr) {
      scope.$watch(attr.chartData, values => {
        $log.debug('[pie-chart] data : ' + toJson(values));
        // Reset chart
        d3.select(element[0]).select('svg').remove();

        // Split data and colors from values
        const ranges: any[] = [];
        const data: any[] = [];
        for (const category in values) {
          if (values.hasOwnProperty(category) && isNumber(values[category]) && values[category] > 0) {
            data.push(values[category]);
            ranges.push(category);
          }
        }

        // Set the color scale
        const color: any = d3.scaleOrdinal().range(ranges);

        // Get the dimensions of the chart
        const container = d3.select(element[0]);
        const width = container.node()['clientWidth'];
        const height = container.node()['clientHeight'];

        // The radius of the pieplot is half the width or half the height (smallest one) minus a margin
        const radius = Math.min(width, height) / 2 - 10;

        // Compute the position of each group on the pie
        const pieLayout = d3.pie().value(d => +d);

        container
          // Append the svg object to the container
          .append('svg')
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMidYMid')
          // Append the svg container and center it
          .append('g')
          .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')
          // Build the pie chart, each part of the pie is a path that we build using the arc function
          .selectAll()
          .data(pieLayout(data))
          .enter()
          .append('path')
          .attr('d', d3.arc().innerRadius(0).outerRadius(radius) as any)
          .attr('fill', d => color(d.index).replace(';', ''))
          .attr('stroke', 'black')
          .style('stroke-width', '1px');
      });
    }

    return {
      restrict: 'E',
      transclude: false,
      template: '<div class="pie-chart-container"></div>',
      link: link,
      replace: true,
    };
  },
];

export default 'cngPieChart';
